import { State } from "./state";
export const initialData: State.Data = {
  recent: [],
  count: -1
};
export const initial: State.Props = {
  data: initialData,
  form: initialData,
  submitRequired: false,
  loadingGet: false,
  loadingPost: false,
  status: "INIT",
  statusMessage: "",
  pending: 0
};
export default initial;
